<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">洛阳垃圾分类大数据监管平台</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              为了帮助洛阳市解决垃圾分类投放监管困难，宣传困难的问题，积极响应国家对于垃圾分类投放、管理的号召。现新增智能垃圾箱设备33台，并配套创建洛阳垃圾分类大数据平台监管中心。每台设备日收纳生活垃圾量300公斤。
            </div>
            <div class="section">
              洛阳垃圾分类大数据监管平台是面向广大居民以及垃圾分类监管有关部门所开发的居民投放以垃圾分类监管平台。有效利用互联网大数据，改善居民垃圾投放的规范性，提高监管的便利性。通过投放垃圾获得积分，积分可以在商城换取对应的礼品，有效普及垃圾分类知识，提高垃圾投放的规范性和积极性。监管部门可以通过后台管理系统对商户，用户，现场督导员等进行全方位的监管。
            </div>

            <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail3/1.png" alt="" />
            </div>
             <div class="section">
              <img src="../../assets/images/zhongzaisheng/detail3/2.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            居民投放以及管理系统:用户可直接通过微信小程序进行注册,利用IC卡或者小程序二维码进行垃圾投放，所有的符合要求的投放方式都会获得相应的积分。
          </div>
          <div class="section">
            分类知识宣传系统:用户可以查看由平台发出的宣传资料以及查询一些分类小知识。并且这些宣传资料和分类小知识会通过微信小程序不定期推送给用户，提高垃圾分类知识的普及程度，加强用户垃圾分类的规范投放意识。
          </div>
          <div class="section">
           管理人员监管系统:通过微信小程序以及GPS对垃圾分类基层管理人员进行管理。加强管理效率，降低管理成本。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseZhongZaiShengDetail3",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZhongZaiShengDetail3.vue